<template>
    <div class="index-content">
        <div class="head-area">
            <head-page @menuClick="menuClick"></head-page>
        </div>
        <div class="content-area">
            <div id="home" class="home-area">
                <home-page></home-page>
            </div>
            <div id="product" class="product-area">
                <product-page></product-page>
            </div>
            <div id="about" class="about-area">
                <about-page></about-page>
                <bottom-page @menuClick="menuClick"></bottom-page>
            </div>
            <div class="bottom-area">
            </div>
        </div>
    </div>
</template>
<script>
import HeadPage from "./page/head.vue";
import HomePage from "./page/home.vue";
import ProductPage from "./page/product.vue";
import AboutPage from "./page/about.vue";
import BottomPage from "./page/bottom.vue";
export default {
    components:{
        HeadPage,
        HomePage,
        ProductPage,
        AboutPage,
        BottomPage
    },
    data(){
        return{

        }
    },
    created(){
        
    },
    mounted(){
    },
    methods:{
        menuClick(menu){
            document.getElementById(menu.id).scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
}
</script>
<style>
    *{
        --head-height:70px;
        --product-top-height:12vh;
    }
    .index-content{
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }
    .content-area{
        width: 100%;
        height: calc(100vh - var(--head-height));
        overflow: auto;
    }
    .head-area{
        width: 100%;
        height: var(--head-height);
        background: #fff;
    }
    .home-area,.product-area,.about-area{
        width: 100%;
        height: 100%;
        background: #fff;
        transition: all 0.5s;
        overflow: hidden;
    }
    .about-area{
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// src/view/index.vue